import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDuration'
})
export class FormatDurationPipe implements PipeTransform {
  transform(duration: string): string {
    return duration.replace(/\b1 (Hours|Minutes|Days|Weeks)\b/, 
      (match, unit) => `1 ${unit.slice(0, -1)}`);
  }
}
